<template functional>
  <div class="foo">
    <el-avatar
      v-if="!props.row.epmployee.imageUrl"
      size="small"
      src="/static/images/avatar-2.jpg"
    ></el-avatar>
    <el-avatar
      v-else
      size="small"
      :src="props.row.epmployee.imageUrl"
    ></el-avatar>
    <span>{{ props.row.epmployee.FullName }}</span>
  </div>
</template>

<script>
export default {
  name: "employeePictureForCXC"
};
</script>

<style scoped>
.foo {
  height: auto;
}
.foo span {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
}
.foo span:first-child {
  margin-right: var(--flex-gap, 0.5em);
}
</style>
